module.exports = __webpack_public_path__ + "img/6.473038c5.png";